import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS, FormGroup } from '@angular/forms';

@Directive({
  selector: '[appRequiredSometimes]',
  providers: [{ provide: NG_VALIDATORS, useExisting: RequiredSometimesDirective, multi: true }]
})
export class RequiredSometimesDirective implements Validator {
  shouldRequire : boolean = false;
  @Input() selectedEntity  = '';
  @Input() controlToCheck  = '';
  @Input() valsToCheck : any[];
  constructor(){}
  validate(control: FormGroup): ValidationErrors|null {
    if(control.controls[this.selectedEntity]?.value){
      var checkMe = this.valsToCheck.filter(v => {return v.val == control.controls[this.selectedEntity]?.value;});
      if(checkMe.length > 0)
      {
        this.shouldRequire = checkMe[0].rqrd;
        if(control.controls[this.controlToCheck].value) this.shouldRequire = false;
      }
      
      return !this.shouldRequire ? null : {'shouldRequire': true};
    }
    return null;
  }
}